import { ORM } from 'redux-orm';

import Course from './course';
import Chat from './chat';
import Ticket from './ticket';
import User from './user';

// Create orm
const orm = new ORM({
  stateSelector: (state) => state.orm,
});

// Register models
orm.register(Course, Chat, Ticket, User);

// Export
export default orm;
